
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casebattles",
      function () {
        return require("private-next-pages/casebattles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casebattles"])
      });
    }
  